import { useSettingsStore } from 'Store/settings'
import { useUserPanelStore } from 'Store/user-panel'
import Cookies from 'js-cookie'
import { CookieKeys } from 'javascript/Constants'

export const showLoginView = () => {
  const settingsStore = useSettingsStore()
  const userPanelStore = useUserPanelStore()

  if (settingsStore.customLoginURL) {
    const loginURL =
      Cookies.get(CookieKeys.BW_ORG_SIGNED_IN) === 'true'
        ? settingsStore.customOrgLoginURL
        : settingsStore.customLoginURL
    window.location = loginURL || settingsStore.customLoginURL
  } else {
    userPanelStore.openPanel(settingsStore.getFacilitySignIn ? 'BookingWidgetIframe' : 'SignIn')
  }
}
